import {
  MESSAGE_CHANNEL,
  MESSAGE_TYPES,
  MESSAGE_STATUSES,
} from "../../../../packages/constants";
import { helpers } from "../../../../packages/helpers";
import { getDateData } from "../get-date-data";
import type { ApiMessageService, MessageService } from "../../types";

const { getStringValue } = helpers.text;
const { getRandomUuid } = helpers.utilities;

export const getMessageServiceData = (
  message: ApiMessageService,
  channel: MESSAGE_CHANNEL
): MessageService => ({
  id: getStringValue(message?.messageId),
  traceId:
    getStringValue(message?.traceId) ||
    getStringValue(message?.messageId) ||
    getRandomUuid("trace_id"),
  authorId: getStringValue(message?.authorId),
  date: getDateData(getStringValue(message?.datetime)),
  editDate: getDateData(getStringValue(message?.datetime)), // TODO заменить на время редактирования сообщения, когда бек реализует

  type: MESSAGE_TYPES.SERVICE,
  status: MESSAGE_STATUSES.RECEIVED,
  channel, // необходим для корректной манипуляции скроллом в списке сообщений

  replyMessage: null,

  content: {
    text: getStringValue(message?.content?.text).trim(),
  },
});
